module.exports = __webpack_public_path__ + "img/scene2copy01.0ccc823f.png";